






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { getOperationID } from '@/api/operations'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import Avancement from '@/components/Group/Avancement.vue'
import { UserModule } from '@/store/modules/user'
import ModulesList from '@/components/ModulesList.vue'
import NewModuleBloc from '@/components/NewModuleBloc.vue'
import { tooltipAtelier } from '@/data/tooltips'

@Component({
    components: {
        SmoothReflow,
        Avancement,
        ModulesList,
        NewModuleBloc,
    },
})
export default class Prog extends Vue {
    @Prop() private group: any
    apiService = new ApiService()
    phasePercent: number = 0
    phase: number = 0
    userID: number
    opeID: number
    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'opacity',
        },
    }

    async mounted() {
        this.userID = UserModule.userInfos.id

        const opeID = await getOperationID()
        this.opeID = opeID
        const opeResp = await this.apiService.getOperation(opeID)
        const ope = opeResp.data
        this.phasePercent = ope.phasePercent
        this.phase = ope.phase

        requestAnimationFrame(() => {
            const $popoverDismiss = $('.popover-dismiss') as any
            $popoverDismiss.popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    get tooltipAtelier() {
        return tooltipAtelier
    }
}
